import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  id: "booking-v4-retail-page-root",
  "data-testid": "booking-v4-retail-page-root",
  class: "flex flex-col h-full relative overflow-hidden"
}
const _hoisted_2 = { id: "booking-v4-header-slot" }
const _hoisted_3 = { class: "flex-1 min-h-0 overflow-y-auto bg-gray-lp-1200" }
const _hoisted_4 = { class: "flex flex-row items-start gap-3 p-3" }
const _hoisted_5 = {
  id: "booking-v4-form-main-column",
  "data-testid": "booking-v4-form-main-column",
  class: "flex-1 min-w-0 flex flex-col gap-y-2"
}
const _hoisted_6 = { class: "flex items-stretch gap-x-3" }
const _hoisted_7 = {
  id: "booking-v4-section-sender",
  class: "flex-shrink-0 min-w-0",
  style: {"flex-basis":"38%"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col items-center justify-between py-1.5 flex-none",
  style: {"gap":"4px"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("div", { class: "flex-1 border-l-2 border-dashed border-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" })
], -1)
const _hoisted_9 = {
  id: "booking-v4-section-receiver",
  class: "flex-1 min-w-0"
}
const _hoisted_10 = { id: "booking-v4-section-reference-number" }
const _hoisted_11 = {
  id: "booking-v4-section-product-type",
  class: "mb-2"
}
const _hoisted_12 = {
  id: "booking-v4-sticky-sidebar",
  "data-testid": "booking-v4-sticky-sidebar",
  class: "shrink-0 sticky top-0 z-20",
  style: {"width":"350px"}
}
const _hoisted_13 = { class: "p-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "border-b border-t border-gray-lp-1600 p-3" }, null, -1)
const _hoisted_15 = { class: "p-3 flex flex-col gap-y-2 " }
const _hoisted_16 = { class: "border-t border-gray-lp-1600  flex flex-col gap-y-2 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderBookingV4 = _resolveComponent("HeaderBookingV4")!
  const _component_SenderSectionV4 = _resolveComponent("SenderSectionV4")!
  const _component_ReceiverSectionV4 = _resolveComponent("ReceiverSectionV4")!
  const _component_BookingSdnBanner = _resolveComponent("BookingSdnBanner")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ReferenceNumberV4 = _resolveComponent("ReferenceNumberV4")!
  const _component_GoodsPackageV4 = _resolveComponent("GoodsPackageV4")!
  const _component_SupportingDocSectionV4 = _resolveComponent("SupportingDocSectionV4")!
  const _component_ProductCardListV4 = _resolveComponent("ProductCardListV4")!
  const _component_FormCompletionPanel = _resolveComponent("FormCompletionPanel")!
  const _component_PaymentMethodSelectorV4 = _resolveComponent("PaymentMethodSelectorV4")!
  const _component_ProtectionPackingSummary = _resolveComponent("ProtectionPackingSummary")!
  const _component_TotalTarifSectionV4 = _resolveComponent("TotalTarifSectionV4")!
  const _component_BookingStickyFooterV4 = _resolveComponent("BookingStickyFooterV4")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalSuccessBookingV4 = _resolveComponent("ModalSuccessBookingV4")!
  const _component_ModalFailedBookingV4 = _resolveComponent("ModalFailedBookingV4")!
  const _component_ModalPreviewInvoice = _resolveComponent("ModalPreviewInvoice")!
  const _component_ModalSuccessReceipt = _resolveComponent("ModalSuccessReceipt")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderBookingV4, {
        ref: "headerBooking",
        activeTab: _ctx.activeTab,
        receiptFormat: _ctx.receiptFormat,
        "onUpdate:activeTab": _ctx.onActiveTabUpdate,
        "onUpdate:receiptFormat": _ctx.onReceiptFormatUpdate
      }, null, 8, ["activeTab", "receiptFormat", "onUpdate:activeTab", "onUpdate:receiptFormat"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex flex-col p-4"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_SenderSectionV4, {
                    ref: "booking-v4-sender-section",
                    modelValue: _ctx.bookingFormV4,
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors = $event)),
                    currentIndex: _ctx.currentIndex,
                    activeTab: _ctx.activeTab,
                    showClientField: _ctx.showClientField,
                    clientIndex: 2,
                    senderNameIndex: 3,
                    senderPhoneIndex: 4,
                    senderAddressIndex: 5,
                    selectedClient: _ctx.clientMetaV4.selectedClient,
                    clientErrorMessage: _ctx.visibleClientSelectionError,
                    clients: _ctx.clients,
                    clientOrigins: _ctx.clientOrigins,
                    selectedClientOrigin: _ctx.selectedOrigin,
                    selectedClientServiceTypes: _ctx.selectedServiceTypes,
                    clientSearchKeyword: _ctx.clientSearchKeyword,
                    isClientInitialLoading: _ctx.isClientInitialLoading,
                    isClientLoadingMore: _ctx.isClientLoadingMore,
                    clientHasNextPage: _ctx.clientHasNextPage,
                    clientListErrorMessage: _ctx.clientListErrorMessage,
                    isClientOriginLoading: _ctx.clientOriginsLoading,
                    clientOriginsHasNextPage: _ctx.clientOriginsHasNextPage,
                    isClient: true,
                    "onUpdate:modelValue": _ctx.onSenderUpdate,
                    "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                    onClientFocus: _ctx.onClientFocus,
                    onClientBlur: _ctx.onClientBlur,
                    onClientTab: _ctx.onClientTab,
                    onClientOpenList: _ctx.onClientListOpen,
                    onClientCloseList: _ctx.onClientListClose,
                    "onUpdate:clientSearch": _ctx.onClientSearchUpdate,
                    "onUpdate:clientOrigin": _ctx.onClientOriginUpdate,
                    "onUpdate:clientServiceTypes": _ctx.onClientServiceTypesUpdate,
                    onClientOriginFocus: _ctx.onClientOriginFocus,
                    onClientOriginFilter: _ctx.onClientOriginFilter,
                    onClientOriginScrolled: _ctx.onClientOriginScrolled,
                    onClientLoadMore: _ctx.onClientLoadMore,
                    onClientSelect: _ctx.onClientSelect,
                    onClientClear: _ctx.onClientClear,
                    onClientRetry: _ctx.onClientRetry,
                    class: "mb-2",
                    onAutofillCommodity: _ctx.onAutofillCommodity,
                    onValidationChange: _ctx.onSenderValidationChange,
                    onSelectPhoneNumber: _ctx.onSelectPhoneNumber
                  }, null, 8, ["modelValue", "errors", "currentIndex", "activeTab", "showClientField", "selectedClient", "clientErrorMessage", "clients", "clientOrigins", "selectedClientOrigin", "selectedClientServiceTypes", "clientSearchKeyword", "isClientInitialLoading", "isClientLoadingMore", "clientHasNextPage", "clientListErrorMessage", "isClientOriginLoading", "clientOriginsHasNextPage", "onUpdate:modelValue", "onUpdate:currentIndex", "onClientFocus", "onClientBlur", "onClientTab", "onClientOpenList", "onClientCloseList", "onUpdate:clientSearch", "onUpdate:clientOrigin", "onUpdate:clientServiceTypes", "onClientOriginFocus", "onClientOriginFilter", "onClientOriginScrolled", "onClientLoadMore", "onClientSelect", "onClientClear", "onClientRetry", "onAutofillCommodity", "onValidationChange", "onSelectPhoneNumber"])
                ]),
                _hoisted_8,
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_ReceiverSectionV4, {
                    ref: "receiverSection",
                    modelValue: _ctx.bookingFormV4,
                    "onUpdate:modelValue": _ctx.onReceiverUpdate,
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                    receiverCountryIndex: _ctx.receiverCountryIndex,
                    receiverNameIndex: _ctx.receiverNameIndex,
                    receiverPhoneIndex: _ctx.receiverPhoneIndex,
                    receiverAddressIndex: _ctx.receiverAddressIndex,
                    receiverDistrictIndex: _ctx.receiverDistrictIndex,
                    receiverPostalCodeIndex: _ctx.receiverPostalCodeIndex,
                    activeTab: _ctx.activeTab,
                    isForeign: _ctx.isAccountForeignPos,
                    isErrorEmbargo: _ctx.isErrorEmbargoDestination,
                    isErrorRouteNotFound: _ctx.errorRouteNotFound,
                    "onUpdate:isErrorRouteNotFound": _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorRouteNotFound = $event)),
                    class: "mb-2",
                    isClient: true,
                    onValidationChange: _ctx.onReceiverValidationChange,
                    onChangeCountry: _ctx.onResetPaymentMethod
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "currentIndex", "onUpdate:currentIndex", "receiverCountryIndex", "receiverNameIndex", "receiverPhoneIndex", "receiverAddressIndex", "receiverDistrictIndex", "receiverPostalCodeIndex", "activeTab", "isForeign", "isErrorEmbargo", "isErrorRouteNotFound", "onValidationChange", "onChangeCountry"])
                ])
              ]),
              _createVNode(_component_BookingSdnBanner, {
                originDistrict: _ctx.districtDetail,
                destinationDistrict: _ctx.bookingFormV4.receiver.destinationCity
              }, null, 8, ["originDistrict", "destinationDistrict"])
            ]),
            _: 1
          }),
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex items-stretch p-4"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_ReferenceNumberV4, {
                  ref: "referenceSection",
                  modelValue: _ctx.bookingFormV4.references,
                  "onUpdate:modelValue": _ctx.onReferencesUpdate,
                  errors: _ctx.errors,
                  "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors = $event)),
                  formContext: "client",
                  accountType: _ctx.accountType,
                  isRequired: _ctx.isReferenceRequired,
                  showValidationError: 
                  _ctx.shouldShowSectionValidationError(
                    _ctx.formCompletionSectionKeyV4.REFERENCE_NUMBER
                  )
                ,
                  selectedClient: _ctx.clientMetaV4.selectedClient,
                  maxItems: 3,
                  onValidationChange: _ctx.onReferenceValidationChange,
                  onFocusin: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(9)))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "accountType", "isRequired", "showValidationError", "selectedClient", "onValidationChange"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Card, {
            rounded: "xl",
            class: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", {
                id: "booking-v4-section-goods-pieces",
                class: "p-4",
                onFocusin: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(11)))
              }, [
                _createVNode(_component_GoodsPackageV4, {
                  ref: "goodsPackageRef",
                  showItemDetails: _ctx.showItemDetails,
                  useDefaultDimensions: !_ctx.isCipl,
                  isFtz: _ctx.isFtzForm,
                  localCurrency: _ctx.formAccountCurrencyCode,
                  currencyPrefix: _ctx.formAccountCurrencyPrefix,
                  numericLocale: _ctx.formAccountCurrencyCode === 'MYR' ? 'my' : 'id',
                  isForeign: _ctx.isForeignAccount,
                  commodityCipl: _ctx.bookingFormV4.commodityCipl,
                  ciplCommodities: _ctx.ciplCommodityOptions,
                  estimatedConversion: _ctx.ciplEstimatedConversion,
                  deminimisThreshold: _ctx.ciplDeminimisThreshold,
                  deminimisExceeded: _ctx.ciplDeminimisExceeded,
                  destinationCurrencyCode: _ctx.dutyTaxDestinationCurrency,
                  recipientImportDocRequired: _ctx.recipientImportDocRequired,
                  selfClearanceRequired: _ctx.selfClearanceRequired,
                  commodity: _ctx.bookingFormV4.commodity,
                  commodities: _ctx.commoditySearchResults,
                  recommendedCommodities: _ctx.commodityRecommendations,
                  savedPackages: _ctx.savedPackages,
                  savedPackagesLoading: _ctx.savedPackagesLoading,
                  customerId: _ctx.bookingFormV4.sender.id,
                  savePackage: _ctx.savePackage,
                  hasSenderId: !!_ctx.bookingFormV4.sender.id,
                  activeSavedPackageId: _ctx.activeSavedPackageId,
                  showSavePackageCheckbox: _ctx.accountType !== 'internal',
                  errors: _ctx.errors,
                  loading: _ctx.commodityListLoading,
                  hasMore: _ctx.commodityListHasMore,
                  modalSearchResults: _ctx.modalSearchResults,
                  commodityCategories: _ctx.commodityCategories,
                  commodityCategoryItems: _ctx.commodityCategoryItems,
                  selectedCategoryCode: _ctx.selectedCategoryCode,
                  modalLoading: _ctx.commodityModalLoading,
                  modalLoadingCategory: _ctx.commodityModalLoadingCategory,
                  modalHasMore: _ctx.commodityModalHasMore,
                  pieces: _ctx.bookingFormV4.pieces,
                  volumeWeightDivisor: _ctx.volumeWeightDivisorForSelectedProduct,
                  hwsConfig: _ctx.hwsConfigForSelectedProduct,
                  maxPieces: _ctx.maxGoodsPieces,
                  singlePieceOnly: 
                  _ctx.receiverSinglePieceOnly || _ctx.interpackSinglePieceOnly
                ,
                  disableAddPiece: _ctx.interpackSinglePieceOnly,
                  isItemDetailsRequired: _ctx.isItemDetailsRequired,
                  "onUpdate:commodityCipl": _ctx.onCommodityCiplUpdate,
                  "onUpdate:commodity": _ctx.onCommodityUpdate,
                  "onUpdate:pieces": _ctx.onPiecesUpdate,
                  onReset: _ctx.onGoodsPackageReset,
                  onCiplValidationChange: _ctx.onCiplValidationChange,
                  onCommodityValidationChange: _ctx.onCommodityValidationChange,
                  onPackageWeightValidationChange: _ctx.onPackageWeightValidationChange,
                  onGrossWeightChange: _ctx.getEstimationPriceDebounced,
                  onSearchCommodity: _ctx.searchCommodity,
                  onLoadMoreCommodities: _ctx.loadMoreCommodities,
                  onSearchCommodityModal: _ctx.searchCommodityModal,
                  onLoadMoreCommodityModal: _ctx.loadMoreCommodityModal,
                  onSelectCommodityCategory: _ctx.selectCommodityCategory,
                  onCommodityError: _ctx.onCommodityError,
                  onSelectSavedPackage: _ctx.onSavedPackageSelect,
                  "onUpdate:savePackage": _ctx.onSavePackageUpdate
                }, null, 8, ["showItemDetails", "useDefaultDimensions", "isFtz", "localCurrency", "currencyPrefix", "numericLocale", "isForeign", "commodityCipl", "ciplCommodities", "estimatedConversion", "deminimisThreshold", "deminimisExceeded", "destinationCurrencyCode", "recipientImportDocRequired", "selfClearanceRequired", "commodity", "commodities", "recommendedCommodities", "savedPackages", "savedPackagesLoading", "customerId", "savePackage", "hasSenderId", "activeSavedPackageId", "showSavePackageCheckbox", "errors", "loading", "hasMore", "modalSearchResults", "commodityCategories", "commodityCategoryItems", "selectedCategoryCode", "modalLoading", "modalLoadingCategory", "modalHasMore", "pieces", "volumeWeightDivisor", "hwsConfig", "maxPieces", "singlePieceOnly", "disableAddPiece", "isItemDetailsRequired", "onUpdate:commodityCipl", "onUpdate:commodity", "onUpdate:pieces", "onReset", "onCiplValidationChange", "onCommodityValidationChange", "onPackageWeightValidationChange", "onGrossWeightChange", "onSearchCommodity", "onLoadMoreCommodities", "onSearchCommodityModal", "onLoadMoreCommodityModal", "onSelectCommodityCategory", "onCommodityError", "onSelectSavedPackage", "onUpdate:savePackage"])
              ], 32)
            ]),
            _: 1
          }),
          (_ctx.showSupportingDocSection)
            ? (_openBlock(), _createBlock(_component_SupportingDocSectionV4, {
                key: 0,
                modelValue: _ctx.bookingFormV4.supportingDoc,
                isFtz: _ctx.isFtzForm,
                isCipl: _ctx.isCipl,
                fieldRules: _ctx.supportingDocFieldRules,
                showRequiredImageErrors: _ctx.hasAttemptedSubmit,
                errors: _ctx.errors,
                "onUpdate:modelValue": _ctx.onSupportingDocUpdate,
                onValidationChange: _ctx.onSupportingDocValidationChange,
                onFocusin: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(20)))
              }, null, 8, ["modelValue", "isFtz", "isCipl", "fieldRules", "showRequiredImageErrors", "errors", "onUpdate:modelValue", "onValidationChange"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, {
            rounded: "xl",
            class: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_ProductCardListV4, {
                  modelValue: _ctx.bookingFormV4.product.productType,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => (_ctx.bookingFormV4.product.productType = $event)),
                    _ctx.onProductTypeSelect
                  ],
                  products: _ctx.productCardItems,
                  showAgentDiscountToggle: false,
                  agentDiscountRevealed: false,
                  agentDiscountToggleEnabled: false,
                  loading: _ctx.productUpsellingLoading,
                  isError: _ctx.productUpsellingIsError,
                  currencyPrefix: _ctx.formCurrencyPrefix,
                  isClient: _ctx.isPriceMasked,
                  hideDiscount: true,
                  "onUpdate:agentDiscountRevealed": _ctx.onAgentDiscountRevealedUpdate,
                  onRetry: _ctx.onProductUpsellingRetry
                }, null, 8, ["modelValue", "products", "loading", "isError", "currencyPrefix", "isClient", "onUpdate:modelValue", "onUpdate:agentDiscountRevealed", "onRetry"])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("aside", _hoisted_12, [
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex flex-col gap-y-2 items-stretch "
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_FormCompletionPanel, {
                  items: _ctx.formCompletionItems,
                  onNavigate: _ctx.onFormCompletionNavigate
                }, null, 8, ["items", "onNavigate"])
              ]),
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_PaymentMethodSelectorV4, {
                  paymentMethod: _ctx.bookingFormV4.paymentMethod,
                  paymentMethodOptions: _ctx.paymentMethodOptions,
                  currencyPrefix: _ctx.formCurrencyPrefix,
                  form: _ctx.bookingFormV4,
                  "onUpdate:paymentMethod": _ctx.onPaymentMethodUpdate
                }, null, 8, ["paymentMethod", "paymentMethodOptions", "currencyPrefix", "form", "onUpdate:paymentMethod"]),
                _createVNode(_component_ProtectionPackingSummary, {
                  modelValue: _ctx.bookingFormV4,
                  protectionPacking: _ctx.bookingFormV4.protectionPacking,
                  currencyPrefix: _ctx.goodsPriceCurrencyPrefix,
                  numericLocale: _ctx.formNumericLocale,
                  isCrossCountryCod: _ctx.isCrossCountryCod,
                  itemPriceError: _ctx.errors.itemPrice,
                  insuranceBasic: _ctx.insuranceBasic,
                  isInsuranceVisible: _ctx.insuranceBasic.isAvailable,
                  paymentMethod: _ctx.bookingFormV4.paymentMethod,
                  isShowCODAmountField: _ctx.isShowCODAmountField,
                  "onUpdate:protectionPacking": _ctx.onProtectionPackingUpdate,
                  onBlurItemPrice: _ctx.onItemPriceBlur,
                  "onUpdate:paymentMethod": _ctx.onPaymentMethodUpdate
                }, null, 8, ["modelValue", "protectionPacking", "currencyPrefix", "numericLocale", "isCrossCountryCod", "itemPriceError", "insuranceBasic", "isInsuranceVisible", "paymentMethod", "isShowCODAmountField", "onUpdate:protectionPacking", "onBlurItemPrice", "onUpdate:paymentMethod"])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_BookingStickyFooterV4, {
                  chargeableWeightKg: _ctx.footerChargeableWeightKg,
                  totalKoli: _ctx.bookingFormV4.pieces.length,
                  chargeableWeightExpanded: 
                  _ctx.bookingFormV4.protectionPacking.chargeableWeightExpanded
                ,
                  "onUpdate:chargeableWeightExpanded": _cache[9] || (_cache[9] = ($event: any) => (
                  _ctx.bookingFormV4.protectionPacking.chargeableWeightExpanded
                 = $event)),
                  chargeableWeightBreakdown: _ctx.chargeableWeightBreakdown,
                  woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                  "onUpdate:protectionPacking": 
                  _ctx.onProtectionPackingUpdateFromCwFooter
                ,
                  numericLocale: _ctx.formAccountNumericLocale
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TotalTarifSectionV4, {
                      modelValue: _ctx.bookingFormV4,
                      estimationPrice: _ctx.bookingFormV4.estimationPrice,
                      currencyPrefix: _ctx.formCurrencyPrefix,
                      codCurrencyPrefix: _ctx.goodsPriceCurrencyPrefix,
                      codCurrencyCode: _ctx.goodsPriceCurrencyCode,
                      paymentMethod: _ctx.bookingFormV4.paymentMethod,
                      itemPrice: _ctx.bookingFormV4.protectionPacking.itemPrice,
                      woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                      protectionChecked: 
                    _ctx.bookingFormV4.protectionPacking.protectionChecked
                  ,
                      isFtz: _ctx.isFtz,
                      isLoading: _ctx.estimationLoading,
                      isError: _ctx.estimationIsError,
                      canOpenDetail: !_ctx.isPriceMasked,
                      isPriceMasked: _ctx.isPriceMasked,
                      isCrossCountryCod: _ctx.isCrossCountryCod,
                      onRefresh: _ctx.onTariffRefresh,
                      hideCodReturnFee: ""
                    }, null, 8, ["modelValue", "estimationPrice", "currencyPrefix", "codCurrencyPrefix", "codCurrencyCode", "paymentMethod", "itemPrice", "woodpacking", "protectionChecked", "isFtz", "isLoading", "isError", "canOpenDetail", "isPriceMasked", "isCrossCountryCod", "onRefresh"])
                  ]),
                  _: 1
                }, 8, ["chargeableWeightKg", "totalKoli", "chargeableWeightExpanded", "chargeableWeightBreakdown", "woodpacking", "onUpdate:protectionPacking", "numericLocale"]),
                _createVNode(_component_LpButton, {
                  class: "mt-4",
                  title: _ctx.$t('bookingV4.footer.bookingAction'),
                  color: "red-lp-2400",
                  textColor: "white",
                  isWidthFull: "",
                  fontWeight: "semibold",
                  "data-testid": "booking-v4-submit",
                  onClick: _ctx.onSubmit
                }, null, 8, ["title", "onClick"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.isSuccessModalVisible)
      ? (_openBlock(), _createBlock(_component_ModalSuccessBookingV4, {
          key: 0,
          modelValue: _ctx.bookingFormV4,
          data: _ctx.successBookingData,
          receiptFormat: _ctx.bookingFormV4.pageMeta.receiptFormat,
          totalPieces: _ctx.bookingFormV4.pieces.length,
          formType: _ctx.successModalFormType,
          currency: _ctx.formAccountCurrencyCode,
          bookingClient: "",
          selectedClient: _ctx.clientMetaV4.selectedClient,
          isCrossCountryCod: _ctx.isCrossCountryCod,
          prefixCurrency: _ctx.goodsPriceCurrencyPrefix,
          onClose: _ctx.onCloseModalSuccess,
          onPrint: _ctx.onPrintSuccessReceipt
        }, null, 8, ["modelValue", "data", "receiptFormat", "totalPieces", "formType", "currency", "selectedClient", "isCrossCountryCod", "prefixCurrency", "onClose", "onPrint"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalFailedBookingV4, _mergeProps({
      modelValue: _ctx.isShowModalFailedBooking,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowModalFailedBooking = $event))
    }, _ctx.modalFailedBookingData, {
      onReload: _ctx.onSubmit,
      onClose: _ctx.closeModalFailed,
      onScrollToDestination: _cache[11] || (_cache[11] = ($event: any) => (
        _ctx.onFormCompletionNavigate(_ctx.formCompletionSectionKeyV4.RECEIVER)
      )),
      onScrollToCod: _cache[12] || (_cache[12] = ($event: any) => (
        _ctx.onFormCompletionNavigate(_ctx.formCompletionSectionKeyV4.PAYMENT_METHOD)
      )),
      onScrollToCommodity: _cache[13] || (_cache[13] = ($event: any) => (
        _ctx.onFormCompletionNavigate(_ctx.formCompletionSectionKeyV4.GOODS_PIECES)
      ))
    }), null, 16, ["modelValue", "onReload", "onClose"]),
    _createVNode(_component_ModalPreviewInvoice),
    (_ctx.isSuccessCreateInvoice)
      ? (_openBlock(), _createBlock(_component_ModalSuccessReceipt, {
          key: 1,
          visible: _ctx.isSuccessCreateInvoice,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (_ctx.isSuccessCreateInvoice = $event)),
          mode: "create",
          invoiceData: _ctx.successCreateInvoiceData,
          onClose: _ctx.onCloseSuccessCreateInvoice,
          onDownload: _ctx.handleDownloadCreateInvoice
        }, null, 8, ["visible", "invoiceData", "onClose", "onDownload"]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ]))
}